<div id="rootContainer" [ngClass]="theme">
  <router-outlet></router-outlet>
</div>
